export default {
  apiError: state => state.apiErrors[0],

  courses: (state, getters) => state.courses.filter(course => {
      return getters.scheduleDisciplines.find(discipline => course.disciplineId === discipline.id)
    }),

  contentTime: state => {
    let total = 0

    state.totalContentTime.forEach(content => {
      total += state.scheduleConfig.materiais_estudo_agenda.includes(content.materialId) ? content.time : 0
    })

    return total
  },

  creationStep: state => state.creationStep,

  disciplines: state => state.disciplines,

  isUpdate: state => state.isUpdate,

  modules: state => state.modules,

  scheduleCourses: state => state.courses.filter(course => state.scheduleConfig.cursos_ids.includes(course.id)),

  scheduleDisciplines: state => {
    return state.disciplines.filter(discipline => state.scheduleConfig.disciplinas_ids.includes(discipline.id))
  },

  scheduleMaterials: state => state.scheduleConfig.materiais_estudo_agenda,

  scheduleModules: state => state.scheduleConfig.modulos_ids,

  scheduleColor: state => state.scheduleConfig.cor,

  scheduleDailyStudyTime: state => state.scheduleConfig.tempo_diario_estudo,

  scheduleId: state => state.scheduleConfig.id,

  scheduleEnd: state => state.scheduleConfig.data_fim,

  scheduleStart: state => state.scheduleConfig.data_inicio,

  scheduleWeekdays: state => state.scheduleConfig.dias_da_semana,

  studyMaterials: state => state.studyMaterials
}
